export const pt_PT = {
    "PREFIX" : {
        "QUESTION"     : "Pergunta",
        "QUESTION-PART": "Pergunta",
        "PRE-RELEASE"  : "Pré-lançamento",
        "JOURNAL"      : "Diário"
    },
    "CONTENT": {
        "MARK"          : "ponto{{totalMarks > 1 && 's' || ''}}"
    }
};